import React from 'react';
import { Button } from '@mui/material';
import { KeyedObject } from 'types';

const GRADIENT_BG = 'linear-gradient(90deg, #612057 0%, #6F358D 100%)';
const GRADIENT_BG_DISABLED = '#D6D6D6';

type Props = {
    id?: string;
    children?: string | React.ReactNode;
    btnClass?: 'primary' | 'secondary' | 'text' | 'secondaryBg' | 'transparentBg';
    rounded?: boolean;
    semiRounded?: boolean;
    space?: boolean; // has left & right margin
    topSpace?: boolean; // has top margin
    width?: string | number;
    fullWidth?: boolean;
    size?: 'small' | 'large' | 'medium';
    sx?: any;
    disableElevation?: boolean;
    href?: string; // for MUI Link
    to?: string; // for React Router Link
    endIcon?: React.ReactNode;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    component?: React.ElementType<any>;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    target?: string;
};

type AttrType = {
    variant?: 'contained' | 'outlined' | 'text';
    sx: KeyedObject;
};

function ImdaButton({ children, btnClass = 'primary', rounded, semiRounded, space, topSpace, width, sx, ...others }: Props) {
    const createAttr = () => {
        const attr: AttrType = { sx: {} };
        switch (btnClass) {
            case 'primary':
                attr.variant = 'contained';
                attr.sx.background = others.disabled ? GRADIENT_BG_DISABLED : GRADIENT_BG;
                attr.sx.color = others.disabled ? '#838185' : '#FFFFFF';
                attr.sx.height = '44px';
                break;
            case 'secondary':
                attr.variant = 'outlined';
                attr.sx.background = '#FFFFFF !important';
                attr.sx.height = '44px';
                break;
            case 'secondaryBg':
                attr.variant = 'contained';
                attr.sx.background = others.disabled ? GRADIENT_BG_DISABLED : GRADIENT_BG;
                attr.sx.color = others.disabled ? '#0074A0' : '#FFFFFF';
                attr.sx.height = '44px';
                break;
            case 'text':
                attr.variant = 'text';
                attr.sx.background = '#FFFFFF !important';
                attr.sx.height = '44px';
                break;
            case 'transparentBg':
                attr.variant = 'text';
                attr.sx.background = 'transparent';
                attr.sx.height = '44px';
                break;
            default:
                attr.variant = 'text';

                break;
        }
        if (rounded) attr.sx.borderRadius = '25px';
        if (semiRounded) attr.sx.borderRadius = '15px';
        if (space) attr.sx.margin = '0 5px';
        if (topSpace) attr.sx.marginTop = '5px';
        if (width) attr.sx.width = width;
        if (sx) {
            Object.keys(sx).forEach((key: string) => {
                attr.sx[key] = typeof sx[key] === 'object' ? { ...sx[key] } : `${sx[key]} !important`;
            });
        }
        return attr;
    };

    return (
        <Button data-testid="testid-button" {...createAttr()} {...others}>
            {children}
        </Button>
    );
}

export default ImdaButton;
